import { render, staticRenderFns } from "./OutingTable.vue?vue&type=template&id=008bf941&scoped=true&lang=pug"
import script from "./OutingTable.vue?vue&type=script&lang=ts"
export * from "./OutingTable.vue?vue&type=script&lang=ts"
import style0 from "./OutingTable.vue?vue&type=style&index=0&id=008bf941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008bf941",
  null
  
)

export default component.exports